// 業態変換一覧のラベル
export const LABELS = {
  HOLDINGS_SEARCH: "検索",
  INDUSTRYCONVERSION_REGISTRATION: "業態変換登録",
  TITLE: "業態変換一覧",
  AFTER_CONVERSION_CODE: "変換後業態コード",
  AFTER_CONVERSION_NAME: "変換後業態名",
  RULE_NO: "ルールNo",
  APPROVAL_STATUS: "ステータス",
  ORIGINALLY_NAME: "変換元業態名",
  ADAPTATION_START_DATE: "適応開始日",
} as const;
// SELECTの空行の定義
export const SELECT_BLANK = { label: "　", value: "" };

// 一覧の1ページ当たりの件数
export const LIST_PAGE_SIZE = 20;
